module.exports = __webpack_public_path__ + "static/media/banner-disclamer-mobile.f45cbd2f.png";